import { ZIndex } from "@/domains/design/constants";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC, ReactNode } from "react";

interface ScreenOverlayProps {
  hideOverlay?: boolean;
  removeOverlay?: boolean;
  children: ReactNode;
}

export const ScreenOverlay: FC<ScreenOverlayProps> = observer(
  ({ children, hideOverlay, removeOverlay }) => {
    return (
      <ScreenOverlayWrapper $hideOverlay={hideOverlay} $removeOverlay={removeOverlay}>
        {children}
      </ScreenOverlayWrapper>
    );
  }
);

const ScreenOverlayWrapper = styled.div<{ $hideOverlay?: boolean; $removeOverlay?: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: ${({ $removeOverlay }) => ($removeOverlay ? "none" : "flex")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: ${ZIndex.ScreenOverlay};
  opacity: ${({ $hideOverlay }) => ($hideOverlay ? 0 : 1)};
  background: ${({ theme }) => theme.colors.surface.chrome};
  transition: opacity 1.08s ease;
  /* We make the whole outer page draggable on desktop. */
  -webkit-app-region: drag;
`;
